import React, { Component } from 'react';
import { observer } from "mobx-react";
import AppStore from 'Stores/AppStore';
import UsersMetricsStore from 'Stores/Metrics/UsersMetricsStore';
import 'Styles/Metrics.scss';
import 'Styles/Stats.scss';
import 'Styles/commonComponents/Table/Table.scss';
import SmrTable from "Components/Common/SmrTable";
import { Link } from 'react-router-dom';
import Checkbox from "Components/Common/checkbox";
import MetricFilters from 'Components/Metrics/MetricFilters';
import FiltersStore from 'Stores/Metrics/FiltersStore';
import { ShowModal, ShowAlert } from "Utils/CommonFunctions";
import Popup from "Components/Common/popup";
import MultiButton from "Components/Common/multiButton";

class UsersMetrics extends Component {

    constructor(props) {
        super(props);

        this.tableStore = {};
    }

    componentDidMount() {
        AppStore.OnMainComponentMount('Список пользователей', 'usersMetrics');

        FiltersStore.GetInitData();
    }

    searchNewMetricUserDLs(pageToSet) {
        if (pageToSet == null)
            pageToSet = 1;

        UsersMetricsStore.GetUsers(pageToSet);
    }

    cleanTableData() {
        UsersMetricsStore.tableStore.CleanStore()
        UsersMetricsStore.usersOnPage = {};
    }


    renderHeader() {
        return (
            <div className="header-row">
                <div className="select-line-column">
                    <Checkbox checked={UsersMetricsStore.selectedMetricUsersIds.length == UsersMetricsStore.lastUsersOnPageIds.length && UsersMetricsStore.lastUsersOnPageIds.length > 0}
                        onChange={(val) => {
                            if (val) {
                                UsersMetricsStore.selectedMetricUsersIds = UsersMetricsStore.lastUsersOnPageIds;
                            } else {
                                UsersMetricsStore.selectedMetricUsersIds = [];
                            }
                        }}
                    />
                </div>
                <div className="column-width-user">Пользователь</div>
                <div className="search-container column-header-width-search">
                    <input
                        id="users-search"
                        placeholder="Поиск по ФИО"
                        value={UsersMetricsStore.searchString}
                        onChange={event => {
                            UsersMetricsStore.searchString = event.target.value;
                            this.searchNewMetricUserDLs();
                        }} />
                </div>
            </div>
        );
    }
    renderHeaderByUserDl() {
        return (
            <div className="header-row">
                <div className="select-line-column column-width-select">
                    <Checkbox checked={UsersMetricsStore.selectedMetricUsersIds.length == UsersMetricsStore.lastUsersOnPageIds.length && UsersMetricsStore.lastUsersOnPageIds.length > 0}
                        onChange={(val) => {
                            if (val) {
                                UsersMetricsStore.selectedMetricUsersIds = UsersMetricsStore.lastUsersOnPageIds;
                            } else {
                                UsersMetricsStore.selectedMetricUsersIds = [];
                            }
                        }}
                    />
                </div>
                <div className="column-width-userdl-username">Пользователь</div>
                <div className="column-width-userdl">Должностное лицо</div>
                <div className="search-container column-header-width-search">
                    <input
                        id="users-search"
                        placeholder="Поиск по ФИО"
                        value={UsersMetricsStore.searchString}
                        onChange={event => {
                            UsersMetricsStore.searchString = event.target.value;
                            this.searchNewMetricUserDLs();
                        }} />
                </div>
            </div>
        );
    }

    renderTableLine(metricUser) {
        return (
            <div className="row"
                key={metricUser.id}>
                <div className="select-line-column column-width-select">
                    <Checkbox
                        className={`${(metricUser.isOpenButtonEnabled == false ? "disabled" : "")}`}
                        checked={metricUser.isOpenButtonEnabled == false ? false : UsersMetricsStore.selectedMetricUsersIds.some(it => it == metricUser.id)}
                        onChange={(val) => {
                            if (val) {
                                UsersMetricsStore.selectedMetricUsersIds.push(metricUser.id);
                            } else {
                                UsersMetricsStore.selectedMetricUsersIds = UsersMetricsStore.selectedMetricUsersIds.filter(it => it != metricUser.id);
                            }
                        }}
                    />
                </div>
                <div className="column-width-user">{metricUser.userName}</div>
                <div className="row-button column-width-button">
                    {
                        metricUser.isOpenButtonEnabled
                            ? (
                                <Link to={`${window.SmrLocation}/userMetrics?id=${metricUser.id}&userId=${metricUser.userId}`} >
                                    <button>
                                        ПОДРОБНЕЕ
                                    </button>
                                </Link>
                            )
                            : (
                                <Popup popupText="Пользователь не работал в мобильном приложении">
                                    <button className="disabled">
                                        ПОДРОБНЕЕ
                                    </button>
                                </Popup>

                            )
                    }
                </div>
            </div>
        );
    }
    renderTableLineByUserDl(metricUserDL) {
        return (
            <div className="row"
                key={metricUserDL.id}>
                <div className="select-line-column column-width-select">
                    <Checkbox
                        className={`${(metricUser.isOpenButtonEnabled == false ? "disabled" : "")}`}
                        checked={metricUser.isOpenButtonEnabled == false ? false : UsersMetricsStore.selectedMetricUsersIds.some(it => it == metricUser.id)}
                        onChange={(val) => {
                            if (val) {
                                UsersMetricsStore.selectedMetricUsersIds.push(metricUserDL.id);
                            } else {
                                UsersMetricsStore.selectedMetricUsersIds = UsersMetricsStore.selectedMetricUsersIds.filter(it => it != metricUserDL.id);
                            }
                        }}
                    />
                </div>
                <div className="column-width-userdl-username">{metricUserDL.userName}</div>
                <div className="column-width-userdl">{metricUserDL.contactOfficialPersonFullName} - {metricUserDL.contactOfficialPersonPost}</div>
                <div className="row-button column-width-button">
                    {
                        metricUserDL.isOpenButtonEnabled
                            ? (
                                <Link to={`${window.SmrLocation}/userMetrics?id=${metricUserDL.id}&contactId=${metricUserDL.contactId}`} >
                                    <button>
                                        ПОДРОБНЕЕ
                                    </button>
                                </Link>
                            )
                            : (
                                <Popup popupText="Пользователь не работал в мобильном приложении">
                                    <button className="disabled">
                                        ПОДРОБНЕЕ
                                    </button>
                                </Popup>

                            )
                    }
                </div>
            </div>
        );
    }

    render() {
        let buttonsPanel = {
            left: [
                <MultiButton title='Сохранить'
                    id='save-button'
                    buttons={[{
                        disabled: UsersMetricsStore.lastUsersCount == 0,
                        title: 'ВЫГРУЗИТЬ ВСЕ',
                        onClick: _ => UsersMetricsStore.ExportUsersData(true)
                    }, {
                        disabled: UsersMetricsStore.selectedMetricUsersIds.length == 0,
                        title: 'ВЫГРУЗИТЬ ВЫДЕЛЕННОЕ',
                        onClick: _ => UsersMetricsStore.ExportUsersData(false)
                    }]}
                    key={'protocol-multi-button'}
                />
            ]
            ,
            right: []
        };

        return (
            <SmrTable className="Table UsersMetrics"
                loading={UsersMetricsStore.usersLoading}
                renderTableLine={this.renderTableLine.bind(this)}
                cleanTableData={this.cleanTableData.bind(this)}
                renderHeader={this.renderHeader.bind(this)}
                getDataPage={this.searchNewMetricUserDLs.bind(this)}
                location={this.props.location}
                buttonsPanel={buttonsPanel}
                setTableStore={tableStore => UsersMetricsStore.tableStore = tableStore}
                cleanTableStore={() => UsersMetricsStore.tableStore = null} />
        );
    }
}

export default observer(UsersMetrics);